import React from 'react';
import './ui.css';

export function YTextarea({ id, value, onChange, placeholder, disabled = false, invalid = false, className = '', rows = 3 }) {
  return (
    <textarea
      id={id}
      className={`y-input ${invalid ? 'is-invalid' : ''} ${className}`.trim()}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      rows={rows}
    />
  );
}
